import styled from 'styled-components';

export const ServicesContainer = styled.div`
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--red);

  @media screen and (max-width: 768px) {
    /* height: 1100px; */
    height: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 480px) {
    height: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 0 0px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: auto;
  width: 300px;
  margin-bottom: 0px;
`;

export const ServicesH1 = styled.h1`
  display: none;
  font-family: var(--font-family-azo_sans-medium);
  color: var(--white);
  font-size: var(--font-size-xl);
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  display: none;
  font-family: var(--font-family-azo_sans-medium);
  color: var(--gray-700);
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
display: none;
  font-family: var(--font-family-montserrat);
  font-size: 1rem;
  text-align: center;
`;
